export default {
  '95%-of-cases': '95% spraw<br>zakończonych jest<br>wypłatą rekompensaty.',
  'add-passenger': 'Dodaj podróżującego',
  'agreement-for': 'Umowa dla {name}',
  back: 'Powrót',
  birthdate: 'Data urodzenia',
  'check-if-you-are-entitled': 'Sprawdź, czy przysługuje<br>Ci rekompensata',
  'check-your-compensation': 'Sprawdź swoją rekompensatę',
  congratulations: 'Gratulacje!',
  'choose-date': 'Wybierz datę',
  'choose-date-from': 'Wybierz datę od',
  'choose-date-to': 'Wybierz datę do',
  'choose-from-the-list': 'Wybierz z listy',
  'choose-option': 'Wybierz opcję',
  clear: 'Wyczyść',
  'congratulations-you-entitled':
    'Gratulujemy, możesz otrzymać do {compensation} Euro rekompensaty!',
  'contact-data': 'Dane osobowe',
  continue: 'Kontynuuj',
  'co-passenger': 'Współpasażer',
  'delete-passenger': 'Usuń podróżującego',
  'departure-date': 'Data wylotu',
  'departed-from': 'Wylot z',
  'dont-have-pesel': 'Nie posiadam numeru PESEL',
  'e-mail-address': 'Adres e-mail',
  'enter-your-pesel':
    'Podaj Twój numer PESEL oraz złóż podpis potwierdzający umowę przelewu wierzytelności dla sprawy numer {number}',
  'final-destination': 'Przylot do',
  finalization: 'Finalizacja',
  'find-us-on': 'Znajdź<br>nas na:',
  'flight-details': 'Szczegóły lotu',
  'flight-information': 'Informacje o locie',
  'flight-verification': 'Weryfikacja lotu',
  finalize: 'Finalizuj!',
  finish: 'Zakończ',
  'first-last-name': 'Imię i nazwisko',
  'first-name': 'Imię',
  'last-name': 'Nazwisko',
  'get-acquainted-with': 'Zapoznaj się ze wzorem umowy',
  here: 'tutaj',
  hours: 'h',
  'how-did-you-find-us': 'Jak do nas trafiłeś/aś?',
  'how-long-was-your-delay':
    'Ile wynosiło Twoje opóźnienie w porcie docelowym?',
  'i-accept-the-conditions': 'Akceptuję regulamin - dostępny',
  'i-accept-the-privacy-policy': 'Akceptuję politykę prywatności - dostępną',
  'i-did-not-reach-the-destination': 'Nie dotarłem/am na miejsce',
  'i-hereby-confirm':
    'Ja, {name}, niniejszym potwierdzam zawarcie Umowy Przelewu Wierzytelności z Passenger Rights sp. z o.o. z siedzibą w Warszawie o numerze {number}.',
  'in-order-to-complete':
    'W celu dopełnienia formalności prosimy o podanie numeru PESEL oraz złożenie podpisu za pomocą kursora lub palca na ekranie monitora',
  'intermediate-airport-only-connecting-flights': 'Przez',
  'invite-co-passengers': 'Zaproś współpasażerów<br>do uzyskania rekompensaty',
  'legal-guardian': 'Opiekun prawny',
  'make-an-electric-signature':
    'Złóż podpis elektroniczny dla {name} {surname}',
  minor: 'Osoba niepełnoletnia',
  minutes: 'min',
  'name-of-the-airline': 'Nazwa linii lotniczej',
  'no-results': 'Brak wyników',
  none: 'Brak',
  'number-interrupted-flight': 'Numer zakłóconego lotu',
  passenger: 'Podróżujący: {name}',
  'passengers-support': 'Dział<br>Wsparcie<br>Pasażerów',
  'pesel-number': 'Numer PESEL',
  'phone-number': 'Telefon kontaktowy',
  description: 'Opis',
  'privacy-policy': 'Polityka prywatności',
  project: 'Projekt',
  'read-about-us': 'Piszą o nas:',
  'ready-accept-the-conditions':
    'Gotowe!<br>Zaakceptuj warunki oraz<br>finalizuj złożenie wniosku',
  regulations: 'Regulamin',
  'report-another-case': 'Zgłoś kolejną sprawę',
  'remember-passengers-know':
    'Pamiętaj, warto poinformować pasażerów o&nbsp;przysługujących im prawach!',
  reset: 'Resetuj',
  'select-the-source': 'Wybierz źródło informacji',
  sign: 'Podpisz',
  'signature-of-the-traveler': 'Podpis podróżnego',
  'start-typing-to-search-airport': 'Zacznij wpisywać, aby odnaleźć lotnisko',
  'start-typing-to-search-airline':
    'Zacznij wpisywać, aby odnaleźć linię lotniczą',
  'thank-you-for-your-thrust':
    'Dziękujemy za zaufanie<br>Passenger Rights Sp. z o.o',
  'we-will-inform':
    'Poinformujemy Cię telefonicznie lub mailowo o rozpoczęciu sprawy lub potrzebie uzupełnienia danych.',
  'what-happened-with-the-flight': 'Co wydarzyło się z lotem?',
  'what-was-the-reason': 'Jaki powód zakłócenia podały linie?',
  'you-are-under': 'Jesteś pod stałą<br>opieką doświadczonych<br>prawników.',
  'you-have-a-problem': 'Masz problem? Pomożemy!',
  'your-application-has-been-submitted':
    'Twoje zgłoszenie zostało przekazane do weryfikacji przez nasz dział prawny.',
  'your-contract-is-below': 'Poniżej znajduje się Twoja umowa',
  'your-risk-nothing':
    'Nic nie ryzykujesz,<br>wypełnij formularz,<br>a my zajmiemy się resztą!',
  'your-route': 'Twoja trasa',
  'error-required': 'To pole jest wymagane',
  'error-to-short-for-compensation':
    'Podany czas jest zbyt krótki, aby uzyskać rekompensatę',
  'error-delay-is-required':
    'Czas opóźnienia lub opcja "Nie dotarłem na miejsce" jest wymagane',
  'error-delay-exclusive':
    'Czas opóźnienia oraz opcja "Nie dotarłem na miejsce" się wykluczają',
  'error-dont-qualify':
    'Niestety podany powód nie kwalifikuje się do uzyskania rekompensaty',
  'error-intermediate-airport':
    'Lotnisko pośrednie nie może być takie samo jak początkowe',
  'error-destination-overlap':
    'Lotnisko końcowe nie może być takie same jak pośrednie lub początkowe',
  'error-invalid-email': 'Niepoprawny adres email',
  'error-invalid-phone': 'Nieprawidłowy numer telefonu',
  'COMMON.ADD': 'Dodaj',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT':
    'Ja, {passengerName}, niniejszym potwierdzam zawarcie Umowy Przelewu Wierzytelności z Passenger Rights sp. z o.o. z siedzibą w Warszawie o numerze {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT_UNDERAGE':
    'Ja, {legalGuardian}, działając w imieniu i na rzecz małoletniego {passengerName}, niniejszym potwierdzam zawarcie Umowy Przelewu Wierzytelności z Passenger Rights sp. z o.o. z siedzibą w Warszawie o numerze {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN': 'Opiekun prawny',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_PLACEHOLDER':
    'imię i nazwisko opiekuna prawnego',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_SIGNATURE':
    'Podpis opiekuna prawnego',
  'SIGN.AGREEMENT.AGREEMENT_FORM.NO_PESEL': 'Nie posiadam numeru PESEL',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_ERROR': 'Niepoprawny numer PESEL',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_NUMBER': 'Numer PESEL',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TITLE':
    'Podaj Twój numer PESEL oraz złóż podpis potwierdzający umowę przelewu wierzytelności dla sprawy numer',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER': 'Podróżujący',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER_SIGNATURE': 'Podpis podróżującego',
  'SIGN.AGREEMENT.AGREEMENT_SETUP.LOADING_CASE': 'Ładowanie zgłoszenia',
  'SIGN.AGREEMENT.CASE_FORM.ADD_DOCUMENTS_TITLE':
    'Dodaj potrzebne dokumenty dla zgłoszenia {passengerName}',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_POPUP':
    'Jeśli brałeś udział w zorganizowanej wycieczce załącz boarding passy i umowę z biurem podróży.',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_SCAN': 'Skan biletu',
  'SIGN.AGREEMENT.SIGNED.AGREEMENT_FOR': 'Umowa dla {passengerName}',
  'SIGN.AGREEMENT.SIGNED.READY_DESCRIPTION':
    'Jesteśmy gotowi do rozpoczęcia procesu uzyskania rekompensaty.\nPoniżej możesz pobrać dokumenty dotyczące sprawy.',
  'SIGN.AGREEMENT.SIGNED.TITLE':
    'Dziękujemy za uzupełnienie danych oraz potwierdzenie umowy przelewu wierzytelności',
  'SIGN.SHARED.CONGRATULATIONS.CASE_NOT_FOUND':
    'Nie znaleźliśmy Twojego zgłoszenia',
  'SIGN.SHARED.CONGRATULATIONS.CONTACT_US':
    'Jeżeli uważasz, że coś poszło nie tak z Twoim zgłoszeniem skontaktuj się z nami!',
  'SIGN.SHARED.CONGRATULATIONS.NOTIFY':
    'Poinformujemy Cie telefonicznie lub mailowo o rozpoczęciu sprawy lub potrzebie uzupełnienia danych.',
  'SIGN.SHARED.CONGRATULATIONS.VERIFICATION':
    'Twoje zgłoszenie zostało przekazane do weryfikacji przez nasz dział prawny.',
  'login-title': 'Logowanie',
  'login-button': 'Zaloguj',
  login: 'Login',
  password: 'Hasło',
  'error-login-or-pass': 'Błędny login lub hasło',
  'add-flight': 'Dodaj lot',
  filter: 'Filtrowanie',
  'filter-button': 'Filtruj',
  'flight-number': 'Nr lotu',
  'flights-list': 'Lista lotów',
  'add-request': 'Dodaj zgłoszenie',
  'how-long-was-delay': 'Ile godzin wynosiło opóźnienie?',
  'planned-arrival': 'Planowany przylot',
  'actual-arrival': 'Rzeczywisty przylot',
  'entitled-amount': 'Kwota odszkodowania',
  'save-flight': 'Zapisz lot',
  'add-new-request': 'Dodaj nowe zgłoszenie',
  'departure-airport': 'Lotnisko początkowe',
  'destination-airport': 'Lotnisko końcowe',
  'prefferred-date-of-first-contact': 'Preferowana data pierwszego kontaktu',
  comments: 'Uwagi',
  'add-comments': 'Wpisz uwagi',
  'add-first-name': 'Wpisz imię',
  'add-last-name': 'Wpisz nazwisko',
  'add-e-mail-address': 'Wpisz adres e-mail',
  'add-description': 'Wpisz dodatkowy opis',
  'add-phone': 'Wpisz numer telefonu',
  deadline: 'Termin',
  'potential-cases': 'Potencjalne sprawy',
  'add-potential-cases': 'Wpisz liczbę',
  'amount-for-customer-czg': 'Kwota dla Klienta CZG (PLN)/Z',
  'amount-for-customer-czd-pre-stage':
    'Kwota dla Klienta CZD etap przedsądowy (PLN)/Z',
  'amount-for-customer-czd-main-stage':
    'Kwota dla Klienta CZD etap sądowy (PLN)/Z',
  'upload-rodo-agreement-file': 'Plik ze zdjeciem zgody RODO',
  'i-agree-data-processing-offer':
    'Passenger Rights S.A. (właściciel marki DELAYFIX) z siedzibą w Warszawie informuje, że przetwarza Państwa dane osobowe w postaci Imienia i nazwiska, adresu e-mail oraz numeru telefonu w celu przedstawienia oferty usługi zawarcia umowy przelewu wierzytelności. Pełna klauzula informacyjna dotycząca przetwarzania danych, znajduje się na stronie internetowej',
  'i-agree-data-processing-complaint':
    'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Passenger Rights S.A. z siedzibą w Warszawie (Al. Ujazdowskie 22/5, 00-478 Warszawa) w celu przedstawienia oferty usługi i dochodzenia rekompensaty od przewoźnika lotniczego, na podstawie Rozporządzenia (WE) 261/2004.',
  'add-amount': 'Wpisz kwotę',
  'save-and-leave': 'Zapisz i wyjdź',
  'save-and-add-new': 'Zapisz i dodaj kolejny',
  'intermediate-airports': 'Lotniska pośrednie',
  'error-both-required': 'Oba pola są wymagane',
  'add-more-data-to-calculate': 'Podaj więcej danych żeby obliczyć',
  footer: {
    claim:
      'Wspieramy pasażerów poszkodowanych w wyniku opóźnionych lub odwołanych lotów',
    'contact-us':
      'Zachęcamy Państwa do kontaktu<br>od poniedziałku do piątku w godzinach:',
    'weekdays-hours': '9:00 - 20:00',
    'on-weekends': 'oraz w soboty w godzinach:',
    'saturday-hours': '10:00 – 18:00',
    'contact-number-href': '+48222929222',
    'contact-number': '+48 222 929 222',
    'contact-email': 'kontakt@delayfix.com',
    follow: 'Znajdź nas i zadaj pytanie na:',
    compensation: 'Sprawdź odszkodowanie',
    rights: 'Twoje prawa',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Kontakt',
    about: 'O nas',
    company: {
      name: 'DelayFix S.A.',
      'address-1': 'Aleje Ujazdowskie 22/5',
      'address-2': '00-478 Warszawa',
      registration:
        'Sąd Rejonowy dla m. st. Warszawy w Warszawie, XII Wydział Gospodarczy Krajowego Rejestru Sądowego, KRS 742480',
      nip: 'NIP 5213681825',
      'capital-1': 'Wysokość kapitału zakładowego:',
      'capital-2': '155 820,00 zł'
    }
  },
  'check-compensation': 'Sprawdź odszkodowanie',
  gdpr: 'RODO',
  'passenger-rights': 'Prawa pasażerów lotniczych',
  terms: 'Regulamin',
  blog: 'Blog',
  contact: 'Kontakt',
  'was-it-with-intermediate': 'Czy ten lot był połączeniem z przesiadką?',
  'add-intermediate': 'Dodaj lotnisko przesiadkowe',
  'intermediate-airport': 'Lotnisko przesiadkowe',
  'preferred-contact-language': 'Preferowany język kontaktu',
  polish: 'polski',
  english: 'angielski',
  russian: 'rosyjski',
  czech: 'czeski',
  'passenger-has-been-added':
    'Do lotu nr {flight} dodano pasażera (nr tel. {phone})',
  'flight-has-been-added': 'Dodano lot {flight}',
  compensation: 'Rekompensata',
  'your-compensation': 'Twoja rekompensata',
  'remove-airport': 'Usuń lotnisko',
  'requests-history': 'Historia zgłoszeń',
  'filters-invalid-search': 'Numer rejsu powinien być dłuższy niż 4 znaki'
}
